<template>
  <div class="main-wrapper">
    <layout-header />
    <layout-sidebar />

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <inbox-header :title="title" :path="path" :text="text" />

        <div class="row align-items-center mb-3">
          <div class="col"></div>
          <div class="col-auto">
            <router-link to="/kiosk-activity-logs" class="btn add-btn">
              <i class="fa fa-desktop"></i> Kiosk Activity Logs
            </router-link>
          </div>
        </div>

        <div class="row filter-row">
          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus focused">
              <vue-select
                :options="moduleList"
                id="employeeList"
                placeholder="-"
                v-model="moduleType"
              />
              <label class="focus-label">Module</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus focused">
              <div class="cal-icon">
                <datepicker
                  v-model="startDate"
                  placeholder="-"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
                <label class="focus-label">Date</label>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <a
              href="javascript:;"
              class="btn btn-success w-100 submit-btn mb-3"
              @click="searchActivity()"
            >
              Search
            </a>
          </div>
          <div class="col-sm-6 col-md-3">
            <a
              href="javascript:;"
              class="btn btn-danger w-100 submit-btn"
              @click="searchActivity(true)"
            >
              Clear
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="showentries mb-3">
              <label>
                Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>

            <div class="table-responsive">
              <a-table
                class="stripped table-hover"
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'changed_by'">
                    {{ record.changed_by?.first_name }}
                    {{ record.changed_by?.last_name }}
                  </template>

                  <template v-else-if="column.key === 'role'">
                    {{ record.changed_by?.roles?.[0]?.name || "—" }}
                  </template>

                  <template v-else-if="column.key === 'designation'">
                    {{ record.changed_by?.designation?.name || "—" }}
                  </template>

                  <template v-else-if="column.key === 'action'">
                    {{ capitalizeFirst(record?.action) || "—" }}
                  </template>

                  <template v-else-if="column.key === 'module_name'">
                    {{ capitalizeFirst(record?.module_name) || "—" }}
                  </template>

                  <template v-else-if="column.key === 'changed_at'">
                    {{ formatDate(record.changed_at) }}
                  </template>

                  <template v-else-if="column.key === 'action_icon'">
                    <a @click="viewActivity(record)">
                      <i class="fa fa-eye"></i>
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <a-modal
          v-model:visible="viewModalVisible"
          title="Activity Details"
          width="60%"
          footer=""
        >
          <p>
            <strong>Module:</strong>
            {{ capitalizeFirst(selectedActivity?.module_name) }}
          </p>
          <p>
            <strong>Action:</strong>
            {{ capitalizeFirst(selectedActivity?.action) }}
          </p>
          <p>
            <strong>Changed By:</strong>
            {{ selectedActivity?.changed_by?.first_name }}
            {{ selectedActivity?.changed_by?.last_name }}
          </p>
          <p>
            <strong>Role:</strong>
            {{ selectedActivity?.changed_by?.roles?.[0]?.name }}
          </p>
          <p>
            <strong>Designation:</strong>
            {{ selectedActivity?.changed_by?.designation?.name }}
          </p>
          <p>
            <strong>Date:</strong>
            {{ formatDate(selectedActivity?.changed_at) }}
          </p>

          <template v-if="selectedActivity">
            <p><strong>Changes:</strong></p>

            <div class="row mt-3">
              <template
                v-if="selectedActivity.old_value && selectedActivity.new_value"
              >
                <div
                  class="col-md-12"
                  v-if="selectedActivity?.module_name === 'attendance'"
                >
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th colspan="3" class="text-center">Comparison</th>
                      </tr>
                      <tr>
                        <th style="width: 33%">Old Value</th>
                        <th style="width: 33%" class="text-center">Field</th>
                        <th style="width: 33%">New Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="i in maxLength" :key="i">
                        <td>
                          <div>
                            <strong>Clock In:</strong>
                            {{
                              formatDate(
                                oldArray[i - 1]
                                  ?.employee_attendances_details_time
                              ) || "NA"
                            }}
                          </div>
                          <div>
                            <strong>Type:</strong>
                            {{ oldArray[i - 1]?.punch_type || "NA" }}
                          </div>
                          <div>
                            <strong>Reason:</strong>
                            {{ oldArray[i - 1]?.punch_out_reason || "NA" }}
                          </div>
                        </td>
                        <td class="text-center align-middle">Entry {{ i }}</td>
                        <td>
                          <div>
                            <strong>Clock In:</strong>
                            {{
                              formatDate(
                                newArray[i - 1]
                                  ?.employee_attendances_details_time
                              ) || "NA"
                            }}
                          </div>
                          <div>
                            <strong>Type:</strong>
                            {{ newArray[i - 1]?.punch_type || "NA" }}
                          </div>
                          <div>
                            <strong>Reason:</strong>
                            {{ newArray[i - 1]?.punch_out_reason || "NA" }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12" v-else>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Old Value</th>
                        <th class="text-center">Field</th>
                        <th>New Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(field, index) in combinedKeys" :key="index">
                        <td>{{ formatValue(oldValueMap[field]) }}</td>
                        <td class="text-center">
                          <strong>{{ formatFieldName(field) }}</strong>
                        </td>
                        <td>{{ formatValue(newValueMap[field]) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>

              <template v-else>
                <div class="col-md-12">
                  <h5>
                    {{ selectedActivity.old_value ? "Old Value" : "New Value" }}
                  </h5>

                  <ul
                    class="list-group overflow-auto border"
                    v-if="selectedActivity.module_name === 'attendance'"
                  >
                    <li
                      class="list-group-item d-flex justify-content-between"
                      v-for="(entry, index) in getActivityEntries()"
                      :key="index"
                    >
                      <div class="w-50">
                        <span
                          ><strong>Clock In:</strong>
                          {{
                            formatDate(entry.employee_attendances_details_time)
                          }}</span
                        >
                      </div>
                      <div class="w-25">
                        <span
                          ><strong>Type:</strong>
                          {{ entry.punch_type || "NA" }}</span
                        >
                      </div>
                      <div class="w-25">
                        <span
                          ><strong>Reason:</strong>
                          {{ entry.punch_out_reason || "NA" }}</span
                        >
                      </div>
                    </li>
                  </ul>
                  <ul class="list-group overflow-auto border" v-else>
                    <li
                      class="list-group-item d-flex justify-content-between"
                      v-for="(value, key, index) in getActivityEntries()"
                      :key="index"
                    >
                      <strong>{{ formatFieldName(key) }}</strong>
                      <span>{{ formatValue(value) }}</span>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </template>
        </a-modal>
        <!-- Modal -->
      </div>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import dayjs from "dayjs";

var pagination = { total: 0, current: 1, pageSize: 10 };

const columns = [
  {
    title: "Sr No.",
    key: "index",
    dataIndex: "index",
    customRender: ({ index }) => {
      return pagination.current === 1
        ? index + 1
        : (pagination.current - 1) * pagination.pageSize + (index + 1);
    },
  },
  {
    title: "Module",
    key: "module_name",
    dataIndex: "module_name",
  },
  {
    title: "Changed By",
    key: "changed_by",
    dataIndex: "changed_by",
  },
  {
    title: "Role",
    key: "role",
    dataIndex: "role",
  },
  {
    title: "Designation",
    key: "designation",
    dataIndex: "designation",
  },
  {
    title: "Date",
    key: "changed_at",
    dataIndex: "changed_at",
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
  },
  {
    title: "View",
    key: "action_icon",
    dataIndex: "action_icon",
  },
];

export default {
  data() {
    // const currentDate = new Date();
    return {
      title: "Activity Logs",
      path: "Dashboard",
      text: "Activity Logs",
      data: [],
      moduleList: [],
      viewModalVisible: false,
      selectedActivity: null,
      columns,
      pagination,
      moduleType: "",
      startDate: "",
      dateFormat: "dd-MM-yyyy",
    };
  },
  mounted() {
    var params = {
      params: { per_page: this.pagination.pageSize },
    };

    this.fetchActivityLogs(params);
    this.fetchModule();
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format("DD MMM YYYY, hh:mm A");
    },
    formatValue(value) {
      if (value === null) return "-";
      if (typeof value === "object") return JSON.stringify(value);
      return value;
    },
    capitalizeFirst(str) {
      if (!str) return "—";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getActivityEntries() {
      return this.selectedActivity.old_value?.length
        ? this.selectedActivity.old_value
        : this.selectedActivity.new_value || [];
    },
    searchActivity(isClear = false) {
      if (isClear) {
        this.moduleType = "";
        this.startDate = "";
      }

      let filters = {
        per_page: this.pagination.pageSize,
      };

      if (this.moduleType) {
        filters.module = this.moduleType;
      }

      if (this.startDate) {
        filters.date = dayjs(this.startDate).format("YYYY-MM-DD");
      }

      const params = {
        params: filters,
      };

      this.fetchActivityLogs(params);
    },
    fetchActivityLogs(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/activity-logs", params)
        .then((response) => {
          this.pagination.total = response.data.data.total;
          this.pagination.current = response.data.data.current_page;
          this.pagination.pageSize = response.data.data.per_page;

          this.data = response.data.data.data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;
          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    fetchModule() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("module-list")
        .then((response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            this.moduleList.push({
              id: response.data.data[i],
              text: this.capitalizeFirst(response.data.data[i]),
            });
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;
          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    handleTableChange(pagesize) {
      let filters = {
        per_page: pagesize.pageSize,
        page: pagesize.current,
      };

      if (this.moduleType) {
        filters.module = this.moduleType;
      }

      if (this.startDate) {
        filters.date = dayjs(this.startDate).format("YYYY-MM-DD");
      }

      const params = {
        params: filters,
      };

      this.fetchActivityLogs(params);
    },
    viewActivity(record) {
      this.selectedActivity = record;
      this.viewModalVisible = true;
    },
    updatePerPage() {
      var param = {
        per_page: this.pagination.pageSize,
      };
      if (this.moduleType) {
        param.module = this.moduleType;
      }

      if (this.startDate) {
        param.date = dayjs(this.startDate).format("YYYY-MM-DD");
      }
      const params = {
        params: param,
      };

      this.fetchActivityLogs(params);
    },
    mergeArrayEntries(arr) {
      let merged = {};
      arr.forEach((entry, index) => {
        for (let key in entry) {
          merged[`${key} [${index + 1}]`] = entry[key];
        }
      });
      return merged;
    },
    formatFieldName(field) {
      if (!field || typeof field !== "string") return "—";
      return field
        .replace(/_/g, " ")
        .replace(/\[\d+\]/g, "")
        .replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
  computed: {
    oldArray() {
      return Array.isArray(this.selectedActivity.old_value)
        ? this.selectedActivity.old_value
        : this.selectedActivity.old_value
        ? [this.selectedActivity.old_value]
        : [];
    },
    newArray() {
      return Array.isArray(this.selectedActivity.new_value)
        ? this.selectedActivity.new_value
        : this.selectedActivity.new_value
        ? [this.selectedActivity.new_value]
        : [];
    },
    maxLength() {
      return Math.max(this.oldArray.length, this.newArray.length);
    },
    oldValueMap() {
      const value = this.selectedActivity?.old_value;
      if (Array.isArray(value)) {
        return this.mergeArrayEntries(value);
      }
      return value || {};
    },
    newValueMap() {
      const value = this.selectedActivity?.new_value;
      if (Array.isArray(value)) {
        return this.mergeArrayEntries(value);
      }
      return value || {};
    },
    combinedKeys() {
      const keys = new Set([
        ...Object.keys(this.oldValueMap || {}),
        ...Object.keys(this.newValueMap || {}),
      ]);
      return Array.from(keys).filter((k) => k); // Filter falsy keys like null or undefined
    },
  },
};
</script>
<style scoped>
.list-group-item {
  font-size: 14px;
  padding: 0.5rem 1rem;
}
.list-group-item {
  word-break: break-word;
  white-space: normal;
}
</style>
